import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {ColorSchemesService} from '../../../modules/configuration/color-schemes/color-schemes.service';
import {ColorSchemeDataModel} from '../../../models/configuration/color-scheme-data.model';
import {TdoColorSchemePickerEvent} from './models/tdo-color-scheme-picker.event';

@Component({
  selector: 'app-tdo-color-scheme-picker',
  templateUrl: './tdo-color-scheme-picker.component.html',
  styleUrls: ['./tdo-color-scheme-picker.component.scss']
})
export class TdoColorSchemePickerComponent implements OnInit {
  isDataSourceWasntReady = false;

  @Input() dataSource: ColorSchemeDataModel[];
  @Input() set selectedColorSchemeId(value: string) {
    if (value === null || value === undefined) {
      this.selectedColorScheme = undefined; 
    }

    if (!this.dataSource) {
      this.isDataSourceWasntReady = true;
    } else {

    }

    const obj = this.dataSource?.find(p => p.ColorSchemeId.toLowerCase() === value);
    if (obj) {
      this.selectedColorScheme = obj;
    } else {
      this.selectedColorScheme = undefined;
    }

    if (value) {
      this._selectedColorSchemeId = value.toLowerCase();
    } else {
      this._selectedColorSchemeId = undefined;
    }
  }
  get selectedColorSchemeId(): string {
    return this._selectedColorSchemeId?.toLowerCase();
  }
  @Input() popoverWidth: number = 220;
  @Input() popoverHeight: number = 200;
  @Input() label: string;
  @Input() popoverXOffset;

  translateX: string;
  private _selectedColorSchemeId: string;

  @Output() schemeChange = new EventEmitter<TdoColorSchemePickerEvent>();

  isShowPicker: boolean = false;
  selectedColorScheme: ColorSchemeDataModel;
  isInitialized: boolean = false;

  constructor(private colorSchemeService: ColorSchemesService) {
    //
  }

  ngOnInit(): void {
    //
    if (!this.isInitialized) {
      this.isInitialized = true;

      if (!this.dataSource) {
        this.colorSchemeService.getColorSchemes().subscribe((data) => {
          this.dataSource = data;
          this.selectedColorScheme = this.dataSource.find(p => p.ColorSchemeId.toLowerCase() === this._selectedColorSchemeId?.toLowerCase());
          this.checkColorScheme();
        });
      } else {
        this.selectedColorScheme = this.dataSource.find(p => p.ColorSchemeId.toLowerCase() === this._selectedColorSchemeId?.toLowerCase());
        this.checkColorScheme();
      }

      if (this.popoverXOffset === undefined) {
        this.translateX = 'translateX(' + ((-this.popoverWidth * 0.5) + 14) + 'px)';
      } else {
        this.translateX = 'translateX(' + (-this.popoverXOffset) + 'px)';
      }
    }
  }

  onColorSchemeClick(model: ColorSchemeDataModel): void {
    this.selectedColorScheme = model;
    this.selectedColorSchemeId = model.ColorSchemeId.toLowerCase();
    this.isShowPicker = false;

    this.schemeChange.emit(new TdoColorSchemePickerEvent(this.selectedColorScheme));
  }

  onColorSchemeRemoveClick(model: ColorSchemeDataModel): void {
    this.selectedColorScheme = null;
    this.selectedColorSchemeId = null;
    model.ColorSchemeId = null;
    this.isShowPicker = false;
    this.schemeChange.emit(new TdoColorSchemePickerEvent(model));
  }

  private checkColorScheme(): void {
    if (this.isDataSourceWasntReady) {
      this.selectedColorSchemeId = this._selectedColorSchemeId;
    } else if (!this.selectedColorScheme) {
      this.selectedColorScheme = undefined;
      this.selectedColorSchemeId = undefined;
    }
  }
}
